import { render, staticRenderFns } from "./DifferenceCard.vue?vue&type=template&id=4bb541da&scoped=true"
import script from "./DifferenceCard.vue?vue&type=script&lang=ts"
export * from "./DifferenceCard.vue?vue&type=script&lang=ts"
import style0 from "./DifferenceCard.vue?vue&type=style&index=0&id=4bb541da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb541da",
  null
  
)

export default component.exports